/**
 * Deterministic seeded pseudo-random generator (mulberry32). Given the same seed it always yields
 * the same sequence — used for reproducible flora variation from `visualSeed` and any other
 * determinism-sensitive procedural code.
 */
export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    // Ensure a non-zero 32-bit integer state.
    this.state = (seed | 0) === 0 ? 0x9e3779b9 : seed >>> 0;
  }

  /** Next float in [0, 1). */
  next(): number {
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Next float in [min, max). */
  range(min: number, max: number): number {
    return min + (max - min) * this.next();
  }

  /** Next integer in [min, max]. */
  int(min: number, max: number): number {
    return Math.floor(this.range(min, max + 1));
  }
}
